import React, { memo } from 'react';
import classNames from 'classnames';
import styles from './ScommesseGroupWrapper.module.scss';
import { useIsAvvenimento } from 'features/sport/hooks';

export type ScommesseGroupWrapperType = {
  testId?: string;
  className?: string;
  scommessaKey: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
};

// eslint-disable-next-line react/display-name
export const ScommesseGroupWrapper = memo(
  function ({ className, children, style, testId, scommessaKey }: ScommesseGroupWrapperType) {
    const isAvvenimento = useIsAvvenimento();

    return (
      <div
        className={classNames(styles.groupWrapper, className, { [styles.fullWidth]: isAvvenimento })}
        data-testid={testId}
        data-scommessaKey={scommessaKey}
        style={style}
      >
        {children}
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.scommessaKey === nextProps.scommessaKey && prevProps.children === nextProps.children
);